





























































































import {
  Vue,
  Component, Watch
} from "@/shared/vuepack";
import {
  AdvisorEventType,
  CustodianStatementLink,
  FeatureFlags,
  HsabAccountNametag,
  HsabSsoDestination,
} from "@/shared/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    SsoDeepLink
  }
})
export default class ResourcesExternalLinkJumbotrons extends Vue {
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  advisorStore = useUserAdvisorStore();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  isNotionalAccountSummariesContainerVisible = false;

  get hsabStatementsDeeplinkLocation () {
    return HsabSsoDestination.Statements;
  }

  @Watch("hsabAccountsStore.accountsFetchState", { immediate: true })
  updateTaxFormContainerVisibility () {
    this.setNotionalAccountSummariesContainerVisible();
  }

  get statement (): CustodianStatementLink | boolean {
    return this.partnerPortalStore.hasPortalAccess && this.custodianSettingsStore.statementsLink;
  }

  get showAccountSummaryLink (): boolean {
    return this.partnerPortalStore.hasPortalAccess && this.custodianSettingsStore.statementsLink
      && (!this.custodianSettingsStore.isHsaBankCustodian || !this.combinedStatementsEnabled);
  }

  get showStatementPreferencesLink (): boolean {
    return this.partnerPortalStore.hasActiveAccount &&
      this.featureFlagStore.featureFlagsAvailable &&
      !!this.custodianSettingsStore.statementPreferencesLink;
  }

  get statementPreferences (): CustodianStatementLink | boolean {
    return this.showStatementPreferencesLink && this.custodianSettingsStore.statementPreferencesLink;
  }

  logTaxEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.SsoTaxLinkClick);
  }

  logStatementEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.EStatementsClick);
  }

  logStatementPreferencesEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.StatementPreferencesClick);
  }

  get combinedStatementsEnabled (): boolean {
    return this.featureFlagStore.featureFlagsAvailable &&
        this.featureFlagStore.flags.bend16780CombinedAccountSummariesEnabled;
  }
  get taxFormContainerIsVisible (): boolean {
    return this.custodianSettingsStore.taxLink !== null
      && (!this.custodianSettingsStore.isHsaBankCustodian ||
        (this.hsabAccountsStore.allHsabAccountsLoaded
            && this.hsabAccountsStore.hsaAccounts !== null
          && !this.combinedStatementsEnabled));
  }
  setNotionalAccountSummariesContainerVisible () {
    const dataLoaded = this.custodianSettingsStore.isHsaBankCustodian && this.hsabAccountsStore.allHsabAccountsLoaded;
    const userHasHsa = this.hsabAccountsStore.hsaAccounts !== null;
    const userHasNotional = this.hsabAccountsStore.notionalAccounts && this.hsabAccountsStore.notionalAccounts.length >
        0;

    this.isNotionalAccountSummariesContainerVisible = dataLoaded && !userHasHsa && userHasNotional
      && !this.combinedStatementsEnabled;
  }
}
